
import { makeStyles } from '@mui/styles';

const styles = (theme) => ({

    container: () => {
      return  {
          display: 'flex',
          height: '100vh',
          width: '100%',

          flexDirection: 'column !important',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'scroll',
      };
    },

    body: () => {
      return  {
        display: 'flex',
        width: '100%',
        height: 'calc(100% - 90px)',
        flexDirection: 'column !important',
        justifyContent: 'flex-start',
        alignItems: 'center',
        overflow: 'hidden',
      };
    },

    /* guide.js  now needs a different styles for the body padding */
    guideBody: () => {
      return  {
        display: 'flex',
        width: 'calc(100% - 64px)',
        height: '100%',
        flexDirection: 'column !important',
        justifyContent: 'flex-start',
        alignItems: 'center',
        overflow: 'hidden',
      };
    },

    subtitle: () => {
      return  {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '20px',
      };
    },

    bodyMessages: () => {
      return  {
        display: 'flex',
        flexDirection: 'column !important',
        fontSize: '14px',
        width: '100%',
        fontWeight: 'regular',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '12px 0px',
        textAlign: 'center',
      };
    },

    guideContentBody: {
      display: 'flex',
      flex: 1,
      paddingLeft: '12px',
      width: '100%',
      height: 'calc(100% - 38px)',
      overflowY: 'auto',
      overflowX: 'hidden',
      flexDirection: 'column !important',
      alignItems: 'center', // Centers the guideContent inside it
      // Scrollbar Styling
      scrollbarGutter: 'stable',
      scrollbarWidth: '12px', 
      scrollbarColor: 'transparent transparent',
      '&::-webkit-scrollbar': { width: '12px' },
      '&::-webkit-scrollbar-thumb': {
          background: 'transparent',
          borderRadius: '5px',
      },
      '&:hover::-webkit-scrollbar-thumb': {
          background: '#D9D9D9',
          backgroundColor: 'transparent', // Shows up on hover
      },
      '&:hover': {
        // Only change the color, not the width/size
        scrollbarColor: '#D9D9D9 transparent',
      },
    },

    guideContent: {
      display: 'flex',
      flexDirection: 'column !important',
      width: 'calc(100% - 64px)',  
      alignItems: 'center',
      paddingBottom: '20px', // Extra breathing room at the bottom of the scroll
    },

    copyButtonOutlined: (p) => {
      const {
        commonUIStyles = {
          copyLinkButton: () => ({}),
        },
      } = p;

      const copyLinkStyles = commonUIStyles.copyLinkButton();
      const styles = {
        backgroundColor: 'transparent !important',
        border: `1px solid ${copyLinkStyles.backgroundColor} !important`,
        color: `${copyLinkStyles.backgroundColor} !important`,
        fontWeight: '400',
        boxShadow: 'none',
      };

      return  {
        '&.MuiButton-root': {
          ...commonUIStyles.copyLinkButton(),
          ...styles,
          '&[disabled]': {
            ...styles,
          },
        },
      };
    },

    copyButtonSolid: (p) => {
      const {
        commonUIStyles = {
          copyLinkButton: () => ({}),
        },
      } = p;

      const copyLinkStyles = commonUIStyles.copyLinkButton();
      const styles = {
        backgroundColor: `${copyLinkStyles.backgroundColor} !important`,
        color: `${commonUIStyles.foreColor()} !important`,
        border: 'none',
      };

      return  {
        '&.MuiButton-root': {
          ...copyLinkStyles,
          ...styles,
          '&[disabled]': {
            ...styles,
          },
        },
      };
    },
 
    nextButton: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      alignItems: 'center',
      marginTop: '6px',
      height: '50px',
      flexDirection: 'column !important',
      flexShrink: 0,
    },
    
    progress: (p) => {
      const {
        commonUIStyles = {
          button: () => ({}),
        },
      } = p;

      return {
        color: `${commonUIStyles.foreColor()} !important`,
      };
    },

    copythislink: {
    
    },

    linkSpace: {
      display: 'flex',
      width: 'calc(100% - 32px)',
      flexShrink: 0,  // Prevents the height from being "squeezed"
      height: '52px',
      fontWeight: 'regular',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',

      marginBottom: '12px',
      border: '1px solid #DEDDDF',
      borderRadius: '8px',
      overflow: 'hidden',
      padding: '0px 10px',
    },

    link: ({ commonUIStyles }) => {
      return {
        ...commonUIStyles.textLink(),
        display: 'block',
        width: '100%',
        fontSize: '14px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        textTransform: 'none',
        minWidth: 0,
        marginRight: '10px',
      };
    },

    copyButtonBase: {
      '&.MuiButtonBase-root': {
        whiteSpace: 'nowrap',
        flexShrink: 0,
        minWidth: 'auto',
        padding: '0 4px',
      }
    },

    help: {
      marginTop: '12px',
      marginBottom: '12px', // Adjusted from 52px to keep it in view
      display: 'flex',
      flexDirection: 'row',
      width: 'calc(100% - 64px)',
      justifyContent: 'center',
      flexShrink: 0, // <--- Prevents the help text from squishing
    },

    banner: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    bannerImage: {
      width: '100%',

      '&[data-platform="windows_ie"]': {
        width: '100%',
      },
    },

    spinnerBox: {
      display: 'flex',
      width: '70%',
    },

    code: {
      backgroundColor: '#f0f0f0',
      marginLeft: '6px',
      marginRight: '6px',
    },

    warning: {
      width: '20px',
      height: '20px',
      marginRight: '4px',
      marginTop: '-5px',
    },

    flowText: () => {
      return  {
        display: 'flex',
        flexDirection: 'row !important',
        fontSize: '14px',
        width: '100%',
        fontWeight: 'regular',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '12px 0px',
        textAlign: 'center',
      };
    },

    stepsList: () => {
      return {
        display: 'flex',
        flexDirection: 'column !important',
        width: '98%',
        marginTop: '8px',
      };
    },

    instructionSubTitle: () => {
      return {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        fontSize: '18px',
        fontWeight: 500,
        marginBottom: '16px',
        padding: '0px 24px',
      };
    },

    stepRow: () => {
      return {
        display: 'flex',
        flexDirection: 'row !important', // Forces horizontal even if body is column
        alignItems: 'flex-start',
        width: '98%',
        marginBottom: '12px',
        textAlign: 'left',  
      };
    },

    stepRowSmallMargin: {
      marginBottom: '4px !important',
    },

    stepRowStep5Margin: {
      marginBottom: '8px !important',
    },

    stepNumber: () => {
      return {
        fontWeight: 'bold',
        display: 'flex',
        fontSize: '14px',
        minHeight: '26px',
        marginRight: '8px',
        
        minWidth: '10px', // Prevents the text from shifting if numbers get wider
      };
    },

    stepNumberCenter: {
      alignItems: 'center',
    },

    stepText: () => {
      return {
        fontSize: '14px',
        lineHeight: '1.4',
        fontWeight: 'regular',
        color: '#333333',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap', // Allows icons to wrap with text if needed
      };
    },

    // Optional: for the Outlook/Calendar icons 
    inlineIcon: {
      width: '26px',
      height: '26px',
      marginLeft: '8px',
      marginRight: '8px',
      verticalAlign: 'middle',
    },
});

export default styles;
export const useStyles = makeStyles(styles);
